import * as WinForm from "../winform";
import { AppName } from "../enum/appConfig";
export class CheckLibs {
    /**是否是大工程师客户端 */
    static isBigEngineer() {
        return WinForm.md.getAppName() === AppName.BigEngineer;
    }
    /**是否是大工程师企业版客户端 */
    static isBigEngineerE() {
        return WinForm.md.getAppName() === AppName.BigEngineerE;
    }
    /**是否是客源宝客户端 */
    static isKYBao() {
        return WinForm.md.getAppName() === AppName.KYBao;
    }
    /**是否是新版大工程师客户端 */
    static isGreatCraftsman() {
        return [AppName.GreatCraftsman, AppName.GreatCraftsmanNj, AppName.Dggj].includes(WinForm.md.getAppName());
    }
    /**是否是新版大工程师企业版客户端 */
    static isGreatCraftsmanEnt() {
        return WinForm.md.getAppName() === AppName.GreatCraftsmanEnt || WinForm.md.getAppName() === AppName.DggjEnt || WinForm.md.getAppName() === AppName.GreatCraftsmanInEnt;
    }
    /**是否是新版客源宝客户端 */
    static isGreatIM() {
        return WinForm.md.getAppName() === AppName.GreatIM;
    }
    /**是否嵌套在iframe中 */
    static isInIframe() {
        return window.self !== window.top;
    }
    /**是否是客户端 */
    static isClient() {
        // return !!(window as any)?.md;
        // @ts-ignore
        return !!(window && window.md);
    }
    /**是否是uniapp */
    static isUniApp() {
        let bol = false;
        try {
            // @ts-ignore
            uni && (bol = true);
        }
        catch (error) {
            bol = false;
        }
        return bol;
    }
}
